const OwnersScoutMap = () =>
  import(
    /* webpackChunkName: "Owners" */ 'src/components/Dashboard/Views/Owners/OwnersScoutMap.vue'
  );
const OwnersScoutList = () =>
  import(
    /* webpackChunkName: "Owners" */ 'src/components/Dashboard/Views/Owners/OwnersScoutList.vue'
  );
const OwnersDirectory = () =>
  import(
    /* webpackChunkName: "Owners" */ 'src/components/Dashboard/Views/Owners/OwnersDirectory.vue'
  );

export const ownersRoutes = [
  {
    path: 'owners/directory',
    name: 'Owner Directory',
    component: OwnersDirectory,
  },
  {
    path: 'owners/scout-map',
    name: 'Scout Map',
    component: OwnersScoutMap,
  },
  {
    path: 'owners/scout-list',
    name: 'Scout List',
    component: OwnersScoutList,
  },
];
